import { updateIntl } from 'react-intl-redux'
import { createIntl, createIntlCache } from 'react-intl'
import countries from 'i18n-iso-countries'
import dotize from 'dotize'
import fr from 'i18n/fr.yaml'
// import en from 'i18n/en.yaml'

const current = localStorage.getItem('locale') || window.navigator.language.split('-').shift()
const fallback = 'fr'
const availables = [
  'fr',
  // 'en',
]

export const locale = availables.includes(current) ? current : fallback
export const messages = {
  fr: dotize.convert(fr),
  // en: dotize.convert(en),
}

countries.registerLocale(require(`i18n-iso-countries/langs/fr.json`))
countries.registerLocale(require(`i18n-iso-countries/langs/en.json`))
export { countries }

localStorage.setItem('locale', locale)

// since it prevents memory leak
const cache = createIntlCache()
export const intl = createIntl(
  {
    locale: 'fr-FR',
    messages: messages[locale],
  },
  cache,
)

updateIntl({ locale, messages: messages[locale] })
